import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function useCustomerDashboardItem(): MenuItem {
  const { t } = useTranslation();
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);

  return {
    label: t('siteHeaderMobile.userMenu.customerDashboard'),
    link: Url.buildFromPath(URLS.CUSTOMER_DASHBOARD),
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: Url.buildFromPath(URLS.CUSTOMER_DASHBOARD),
      menu_item: 'customer_dashboard',
      menu_name: 'profile',
    }),
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
